import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const CTABanner = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [settings, setSettings] = useState({});
  const sectionRef = useRef(null);

  useEffect(() => {
    fetchSettings();
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await axios.get(`${BACKEND_URL}/api/cms/settings`);
      setSettings(response.data);
    } catch (error) {
      console.error('Error fetching settings:', error);
    }
  };

  const primaryColor = settings.primary_color || '#0A1A50';
  const textColor = settings.text_color || '#2d2d2d';

  return (
    <section 
      ref={sectionRef} 
      className="py-20"
      style={{ backgroundColor: primaryColor }}
    >
      <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
        <h2
          className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light mb-4"
          style={{
            color: textColor,
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.8s ease-out, transform 0.8s ease-out'
          }}
        >
          {settings.cta_title || 'Efficiency. Execution. Expertise.'}
        </h2>
        <p
          className="text-white text-lg sm:text-xl font-light"
          style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? 'translateY(0)' : 'translateY(20px)',
            transition: 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s'
          }}
        >
          {settings.cta_subtitle || 'Create your success story with'}{' '}
          <span className="font-normal">{settings.cta_brand || 'Reagle.'}</span>
        </p>
      </div>
    </section>
  );
};

export default CTABanner;